/* =========================================================
   ZECCI HEADER
   Mega Menu + Mobile Menu
   ========================================================= */

(() => {
  'use strict';

  const initZecciHeader = () => {
    const header = document.querySelector('[data-zecci-header]');

    if (!header) return;

    const menuItems = Array.from(
      header.querySelectorAll('[data-zecci-menu-item]')
    );

    const mobileMenu = header.querySelector('[data-zecci-mobile]');
    const openButton = header.querySelector('[data-zecci-open]');
    const closeButton = header.querySelector('[data-zecci-close]');

    const closeDesktopMenus = () => {
      menuItems.forEach((item) => {
        item.classList.remove('is-open');

        const trigger = item.querySelector('.zecci-nav__trigger');
        const mega = item.querySelector('[data-zecci-mega]');

        if (trigger) {
          trigger.setAttribute('aria-expanded', 'false');
        }

        if (mega) {
          mega.setAttribute('aria-hidden', 'true');
        }
      });
    };


    const openDesktopMenu = (item) => {
      menuItems.forEach((otherItem) => {
        if (otherItem !== item) {
          otherItem.classList.remove('is-open');

          const otherTrigger =
            otherItem.querySelector('.zecci-nav__trigger');

          const otherMega =
            otherItem.querySelector('[data-zecci-mega]');

          if (otherTrigger) {
            otherTrigger.setAttribute(
              'aria-expanded',
              'false'
            );
          }

          if (otherMega) {
            otherMega.setAttribute(
              'aria-hidden',
              'true'
            );
          }
        }
      });


      item.classList.add('is-open');

      const trigger =
        item.querySelector('.zecci-nav__trigger');

      const mega =
        item.querySelector('[data-zecci-mega]');

      if (trigger) {
        trigger.setAttribute(
          'aria-expanded',
          'true'
        );
      }

      if (mega) {
        mega.setAttribute(
          'aria-hidden',
          'false'
        );
      }
    };


    /* =====================================================
       DESKTOP MENU CLICK
       ===================================================== */

    menuItems.forEach((item) => {
      const trigger =
        item.querySelector('.zecci-nav__trigger');

      if (!trigger) return;

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const isOpen =
          item.classList.contains('is-open');

        if (isOpen) {
          closeDesktopMenus();
        } else {
          openDesktopMenu(item);
        }
      });


      /* Desktop hover */

      item.addEventListener('mouseenter', () => {
        if (window.innerWidth < 1101) return;

        openDesktopMenu(item);
      });
    });


    /* =====================================================
       DESKTOP LEAVE
       ===================================================== */

    const nav = header.querySelector('.zecci-nav');

    if (nav) {
      nav.addEventListener('mouseleave', () => {
        if (window.innerWidth < 1101) return;

        closeDesktopMenus();
      });
    }


    /* =====================================================
       CLICK OUTSIDE
       ===================================================== */

    document.addEventListener('click', (event) => {
      if (!header.contains(event.target)) {
        closeDesktopMenus();
      }
    });


    /* =====================================================
       ESCAPE
       ===================================================== */

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeDesktopMenus();
        closeMobileMenu();
      }
    });


    /* =====================================================
       MOBILE MENU OPEN
       ===================================================== */

    const openMobileMenu = () => {
      if (!mobileMenu) return;

      mobileMenu.classList.add('is-open');

      mobileMenu.setAttribute(
        'aria-hidden',
        'false'
      );

      if (openButton) {
        openButton.setAttribute(
          'aria-expanded',
          'true'
        );
      }

      document.documentElement.classList.add(
        'zecci-menu-open'
      );

      document.body.classList.add(
        'zecci-menu-open'
      );
    };


    /* =====================================================
       MOBILE MENU CLOSE
       ===================================================== */

    function closeMobileMenu() {
      if (!mobileMenu) return;

      mobileMenu.classList.remove('is-open');

      mobileMenu.setAttribute(
        'aria-hidden',
        'true'
      );

      if (openButton) {
        openButton.setAttribute(
          'aria-expanded',
          'false'
        );
      }

      document.documentElement.classList.remove(
        'zecci-menu-open'
      );

      document.body.classList.remove(
        'zecci-menu-open'
      );
    }


    if (openButton) {
      openButton.addEventListener(
        'click',
        openMobileMenu
      );
    }


    if (closeButton) {
      closeButton.addEventListener(
        'click',
        closeMobileMenu
      );
    }


    /* =====================================================
       MOBILE LINKS
       Close menu after navigation
       ===================================================== */

    if (mobileMenu) {
      mobileMenu
        .querySelectorAll('a')
        .forEach((link) => {

          link.addEventListener('click', () => {
            closeMobileMenu();
          });

        });
    }


    /* =====================================================
       MOBILE DETAILS
       Close other accordion items
       ===================================================== */

    if (mobileMenu) {

      const details =
        mobileMenu.querySelectorAll(
          '.zecci-mobile-item'
        );

      details.forEach((current) => {

        current.addEventListener(
          'toggle',
          () => {

            if (!current.open) return;

            details.forEach((other) => {

              if (other !== current) {
                other.open = false;
              }

            });

          }
        );

      });

    }


    /* =====================================================
       RESIZE
       ===================================================== */

    let previousWidth =
      window.innerWidth;

    window.addEventListener(
      'resize',
      () => {

        const currentWidth =
          window.innerWidth;

        if (
          previousWidth <= 749 &&
          currentWidth > 749
        ) {
          closeMobileMenu();
        }

        if (
          previousWidth > 749 &&
          currentWidth <= 749
        ) {
          closeDesktopMenus();
        }

        previousWidth =
          currentWidth;

      },
      { passive: true }
    );

  };


  /* =======================================================
     INIT
     ======================================================= */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initZecciHeader
    );

  } else {

    initZecciHeader();

  }

})();